import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/order',
  redirect: '/order/orderList',
  component: SubLayout,
  children: [
    {
      path: 'orderList',
      name: 'orderList',
      meta: {
        title: '订单管理'
      },
      component: () => import('@/views/order/Index')
    },
    {
      path: 'stockUpList/:subId',
      name: 'StockUpList',
      meta: {
        title: '配货信息'
      },
      component: () => import('@/views/order/StockUpList')
    }
  ]
}

export default routes
